export default __webpack_public_path__ + "static/google-workspace-sync-d7f708abc943975b1079f44b4518bcae.mp4";